import React, { Dispatch, useEffect } from 'react';
import { createContext, FC, ReactNode, useContext, useReducer } from 'react';
import { Route, Routes } from 'react-router-dom';
import clsx from 'clsx';
import LoginPage from 'pages/LoginPage';
import CreateAccountAndPurchaseAppPage from 'pages/PurchaseProductPage/CreateAccountAndPurchaseAppPage';
import Przelewy24Page from 'pages/PurchaseProductPage/Przelewy24Page';
import ResetPasswordPage from 'pages/ResetPasswordPage';
import { SubscriptionPurchaseProvider } from 'utils/context/SubscriptionPurchaseContext';

import { UserActions } from './Actions';
import { Action, reducer } from './Reducer';
import { initialState, State } from './State';

interface ProviderProperties {
    children: ReactNode;
}

export const hasValidSubscription = (userRole: string): boolean => {
    return userRole.includes('ROLE_SUBSCRIBE');
};

const Context = createContext<State>(initialState);
const DispatchContext = createContext<Dispatch<Action>>(() => null);

export const UserProvider: FC<ProviderProperties> = ({ children }) => {
    const [user, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const checkAuthForComponent = async () => {
            const token = localStorage.getItem('MonitorApiToken');

            if (token && !user.isLogged) {
                await UserActions.loginByToken(dispatch, false);
            }
        };

        checkAuthForComponent();
    }, []);

    return (
        <Context.Provider value={user}>
            <DispatchContext.Provider value={dispatch}>
                <SubscriptionPurchaseProvider>
                    <div className={clsx({ light: !user.isDarkMode, dark: user.isDarkMode })}>
                        {user.isLogged
                            ? children
                            : <Routes>
                                <Route
                                    path="/create-account-purchase-app"
                                    element={<CreateAccountAndPurchaseAppPage />}
                                />
                                <Route
                                    path="/reset-password"
                                    element={<ResetPasswordPage/>}
                                />
                                <Route
                                    path="/przelewy24"
                                    element={<Przelewy24Page />}
                                />
                                <Route path="*" element={<LoginPage />} />
                            </Routes>
                        }
                    </div>
                </SubscriptionPurchaseProvider>
            </DispatchContext.Provider>
        </Context.Provider>
    );
};

export const useUser = () => {
    return {
        user: useContext(Context),
        dispatch: useContext(DispatchContext)
    };
};
